import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationIT from './locales/it.json';
import translationEN from './locales/en.json';
import translationZH from './locales/zh.json';
import translationES from './locales/es.json';

const resources = {
  it: {
    translation: translationIT
  },
  en: {
    translation: translationEN
  },
  zh: {
    translation: translationZH
  },
  es: {
    translation: translationES
  }
};

// Ottieni la lingua preferita dall'utente se disponibile
const preferredLanguage = localStorage.getItem('preferredLanguage');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: preferredLanguage || 'it', // Usa la lingua preferita se disponibile, altrimenti usa l'italiano
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n; 